<template>
  <div>
    <!-- <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请设置提示语"/>
    </el-form-item> -->
    <el-form-item label="类型">
      <!-- <el-switch v-model="value.multiple"></el-switch> -->
      <el-radio-group v-model="value.multiple">
        <el-radio :label="false"><span class="name-text">只能选择一个部门</span></el-radio>
        <el-radio :label="true"><span class="name-text">可同时选择多个部门</span></el-radio>
      </el-radio-group>
    </el-form-item>
  </div>

</template>

<script>
export default {
  name: "OrgPicker",
  components: {},
  props:{
    value:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

   .name-text{
      font-size: 14px;
      color: #2F3030;
      line-height: 28px;
    }
</style>